import { render, staticRenderFns } from "./Game501.vue?vue&type=template&id=83428df2&scoped=true&"
import script from "./Game501.vue?vue&type=script&lang=js&"
export * from "./Game501.vue?vue&type=script&lang=js&"
import style0 from "./Game501.vue?vue&type=style&index=0&id=83428df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83428df2",
  null
  
)

export default component.exports